import { FieldDesignChangeStatus, Permission } from 'shared'
import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { useFDCTrackerContext } from '../../../FDCTrackerContext'
import { FieldDesignChange } from '../../../FDCTrackerContext/types'
import { useClosedDisabledMessage } from '../../../../../../../../../../components/CIMSTable/common/hooks/useClosedDisabledMessage'

export function useRemoveOptions(): RemoveRowActionOptions<FieldDesignChange> {
  const {
    mutations: { remove },
    fieldDesignChanges,
  } = useFDCTrackerContext()
  return {
    permission: Permission.RemoveRestoreFieldDesignChange,
    disabled: useClosedDisabledMessage('removed', [
      FieldDesignChangeStatus.Closed,
      FieldDesignChangeStatus.Unlocked,
    ]),
    onRemove: async ({ id }) => {
      await remove.fn({ variables: { id } })
      fieldDesignChanges?.refetch()
    },
  }
}
